import { render, staticRenderFns } from "./UserProviderFeed.vue?vue&type=template&id=e1b2dfa4&scoped=true&"
import script from "./UserProviderFeed.vue?vue&type=script&lang=js&"
export * from "./UserProviderFeed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1b2dfa4",
  null
  
)

export default component.exports